export default {
  /**
   * Capitalizes the first letter of a string and replaces underscores with spaces.
   *
   * @param {String} str - string to capitalize and replace
   * @returns {String} - resulting string
   */
  capitalizeAndReplaceUnderscore(str) {
    if (typeof str !== 'string') {
      throw new Error(
        `capitalizeAndReplaceUnderscore() type error - parameter str is not a string.`,
      );
    }

    return this.capitalize(this.replaceUnderscore(str));
  },

  /**
   * Capitalizes the first letter of a string.
   *
   * @param {String} str - string to capitalize
   * @returns {String} - resulting string
   */
  capitalize(str) {
    if (typeof str !== 'string') {
      throw new Error(`capitalize() type error - parameter str is not a string.`);
    }

    return str[0].toUpperCase() + str.slice(1);
  },

  replaceUnderscore(str) {
    if (typeof str !== 'string') {
      throw new Error(`replaceUnderscore() type error - parameter str is not a string.`);
    }

    return str.replace(/_/g, ` `);
  },
};



// WEBPACK FOOTER //
// ./src/utils/string.js